module.exports = __webpack_public_path__ + "img/left2.c279b4b7.svg";